import {
    API_PURCHASE_getInfo,
    API_PURCHASE_qualifyPurchase,
    API_PURCHASE_quickBuy,
    API_TOKEN_STORAGE,
} from '../../constants/endpoints'
import { controller } from '../../utilities/abortController'
import { PurchaseInfoResponse } from '../tokenPurchaseOptions'
import { EdgeApiResponse, fetchStatusResolver } from './utilities'

export async function _fetchPostQuickbuy(params) {
    const resp = await fetch(API_PURCHASE_quickBuy, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
        signal: controller.signal,
    })
    return await resp.json()
}

export async function _fetchQualifyPurchase(params) {
    const endpoint = API_PURCHASE_qualifyPurchase
    const queryString = Object.keys(params)
        .map((key) => key + '=' + params[key])
        .join('&')
    const query = queryString ? '?' + queryString : ''
    const resp = await fetch(endpoint + query, {
        credentials: 'include',
        signal: controller.signal,
    })
    return await resp.json()
}

export async function _fetchTokenConfig(): Promise<PurchaseInfoResponse> {
    const url = API_PURCHASE_getInfo
    try {
        const resp = await fetch(url, {
            credentials: 'include',
            method: 'GET',
            signal: controller.signal,
        }).then(fetchStatusResolver)
        return (await resp.json()) as PurchaseInfoResponse
    } catch (ex) {
        console.error(`[_fetchTokenConfig]: Error fetching ${ex}`)
    }
}

interface TokenStorageResult {
    message: string
    shift: string
    tokens: number
    token_storage: number
}
interface TokenStorageParams {
    request_id: number
    shift: number
    token: string
}

export async function _fetchPostShiftTokenStorage(params: TokenStorageParams) {
    const res = await fetch(API_TOKEN_STORAGE, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
        signal: controller.signal,
    })
    const resp = (await res.json()) as EdgeApiResponse<TokenStorageResult>
    if (typeof resp !== 'object' || resp.errmsg) {
        return {
            errmesg: resp.errmsg
                ? resp.errmsg
                : 'There was a problem with Token Storage. Please contact support, or try again later.',
        }
    }
    return { message: resp.result?.message }
}
